import React, { Component } from 'react';
import './AddInvoiceForm.css';
import { Col, ControlLabel, Form, FormGroup } from 'react-bootstrap';
import uploadSvg from 'images/upload.svg';
import Dropzone from 'react-dropzone';
import PropTypes from 'prop-types';
import { Contractor } from 'domain/contractor';
import ConfirmationModal from 'components/shared/modal/ConfirmationModal';
import MessageModal from 'components/shared/modal/MessageModal';
import invalidPng from 'images/invalid.png';
import { TaskStatusEnum } from 'domain/task-status-enum';
import numeral from 'numeral';

export default class AddInvoiceForm extends Component {
  static propTypes = {
    quotes: PropTypes.arrayOf(PropTypes.shape({})),
    changeOrderTasks: PropTypes.arrayOf(PropTypes.shape({})),
    onSubmit: PropTypes.func.isRequired,
  };

  static defaultProps = {
    tasks: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      file: null,
      showConfirmation: false,
    };
    this.cost = Contractor.getTotalCost(
      props.quotes,
      props.changeOrderTasks,
      true
    );
  }

  handleConfirmation = (response) => {
    if (response) {
      this.props.onSubmit({
        cost: this.cost,
        document: this.state.file,
      });
    }
    this.setState({
      file: null,
      showConfirmation: false,
    });
  };

  handleFiles = (files) => {
    this.validInvoiceUpload()
      ? this.setState({
          file: files[0],
          showConfirmation: true,
        })
      : this.showInvalidUploadMsg();
  };

  validateInvoiceUpload = (e) => {
    if (!this.validInvoiceUpload()) {
      this.showInvalidUploadMsg();
      e.stopPropagation();
    }
  };

  validInvoiceUpload = () => {
    const { tasks } = this.props;
    return (
      tasks.filter((task) => {
        return (
          TaskStatusEnum.CMP.equals(task.status) ||
          TaskStatusEnum.CLS.equals(task.status)
        );
      }).length === tasks.length
    );
  };

  showInvalidUploadMsg = () => {
    this.setState({ showInvalidUploadMsg: true });
  };

  hideInvalidUploadMsg = () => {
    this.setState({ showInvalidUploadMsg: false });
  };

  render() {
    const { showInvalidUploadMsg } = this.state;
    return (
      <div className="add-invoice-form">
        <Form horizontal>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={3}>
              Document
            </Col>
            <Col sm={9}>
              <Dropzone
                accept="application/pdf, .doc, .docx, .xls, .xlsx"
                className="dropzone-container"
                multiple={false}
                onDrop={this.handleFiles}
              >
                <div onClick={this.validateInvoiceUpload}>
                  <span>Please drag and drop any file into this area</span>
                  <img src={uploadSvg} alt="upload" />
                </div>
              </Dropzone>
            </Col>
          </FormGroup>
        </Form>

        <ConfirmationModal
          show={this.state.showConfirmation}
          message={`Please confirm that the invoice amount is for ${numeral(
            this.cost
          ).format('$0,0')}`}
          onHide={this.handleConfirmation}
        />

        {showInvalidUploadMsg && (
          <MessageModal
            show={showInvalidUploadMsg}
            message="Please complete task checklist and submit a completed photo before submitting your invoice"
            icon={invalidPng}
            onHide={this.hideInvalidUploadMsg}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/contractors-invoices/AddInvoiceForm.js